import axiosInstance from './axiosInstance';

const tasksService = {
  fetchTaskHelp: async (taskDescription) => {
    try {
      const response = await axiosInstance.post('/tasks/help', { description: taskDescription });
      return response.data; // Assuming the API response structure
    } catch (error) {
      console.error('Error fetching task help:', error.response?.data || error.message);
      throw error;
    }
  },
  updateTask: async (fields) => {
    try {
      const response = await axiosInstance.post('/tasks/update-task', fields);
      return response.data.tasks;
    } catch (error) {
      console.error('Error fetching goal:', error.response?.data || error.message);
      throw error;
    }
  },
};

export default tasksService;
